import React from 'react';
import { runsHistory } from '../mock/mock';

const colorMap = {
  orange: { fill: '#fb923c', ring: 'rgba(251,146,60,0.35)' },
  cyan: { fill: '#22d3ee', ring: 'rgba(34,211,238,0.35)' },
  pink: { fill: '#ec4899', ring: 'rgba(236,72,153,0.35)' },
  green: { fill: '#34d399', ring: 'rgba(52,211,153,0.35)' },
};

const RunsTimeline = () => {
  return (
    <section className="rounded-2xl border border-white/5 bg-black/20 p-4 flex flex-col">
      <div className="flex items-center justify-between mb-3">
        <p className="text-[10px] uppercase tracking-[0.25em] text-white/40 font-mono">Historique des runs</p>
        <span className="text-[9px] font-mono text-white/40">{runsHistory.length} entrées</span>
      </div>
      <div className="relative flex-1 overflow-hidden">
        {/* Vertical rail */}
        <div className="absolute left-[22px] top-2 bottom-2 w-px bg-gradient-to-b from-transparent via-white/15 to-transparent" />
        <div className="space-y-2.5 max-h-[420px] overflow-y-auto pr-1">
          {[...runsHistory].reverse().map((r, i) => {
            const c = colorMap[r.color] || colorMap.cyan;
            return (
              <div key={r.id + i} className="flex items-center gap-3 group cursor-pointer" style={{ animation: `card-in 0.4s ease ${i * 0.03}s both` }}>
                <div
                  className="relative h-11 w-11 rounded-full grid place-items-center border-2 flex-shrink-0 group-hover:scale-110 transition-transform"
                  style={{ borderColor: c.fill, boxShadow: `0 0 12px ${c.ring}`, background: 'rgba(0,0,0,0.7)' }}
                >
                  <span className="font-mono text-[10px] font-bold" style={{ color: c.fill }}>{r.id}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-mono text-xs text-white/85 truncate">{r.site}</p>
                  <p className="font-mono text-[10px] text-white/40">{r.date}</p>
                </div>
                <div className="text-[9px] font-mono uppercase tracking-widest px-2 py-0.5 rounded" style={{ background: `${c.fill}18`, color: c.fill }}>
                  {r.color === 'green' ? 'OK' : r.color === 'pink' ? 'ALERT' : r.color === 'cyan' ? 'INFO' : 'WARN'}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default RunsTimeline;
